var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWandSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-wand-sparkles",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14 7 3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6v4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14v4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2v2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16h-4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandSparkles);
export default __webpack_public_path__ + "static/media/wand-sparkles.4db2694147eaad8eb9753292fe0d4674.svg";
export { ForwardRef as ReactComponent };